import { WeatherModule } from '~/models/modules/netatmo/WeatherModule.model';

export class NAModule1 extends WeatherModule {

    loadData(data: any) {
        super.loadData(data);
        this.loadOffset(data.offset);
    }

}
